import firebase from "firebase/app";
import "firebase/auth"; // for authentication
import "firebase/storage"; // for storage
import "firebase/database"; // for realtime database
import "firebase/firestore"; // for cloud firestore
import "firebase/messaging"; // for cloud messaging
import "firebase/functions"; // for cloud functions
const firebaseConfig = {
  apiKey: "AIzaSyB7ytMUxRvfhYrr3XN2_PfHYPol26-IZzQ",
  authDomain: "audiobook-310902.firebaseapp.com",
  projectId: "audiobook-310902",
  storageBucket: "audiobook-310902.appspot.com",
  messagingSenderId: "188877079451",
  appId: "1:188877079451:web:fdcddd51fd6ad6e460573e",
  measurementId: "G-45YRV6NZXJ",
};
// Initialize Firebase
!firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();
export default firebase;
